import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { DisplayWebContentNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/DisplayWebContentNode';
import { uuid } from 'utils';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

import { useLinkToDisplayWebContent } from '../../SendEmail/state/actions/useLinkToDisplayWebContent';

export const useAddDisplayWebContentToWorkflow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const { dispatch: editorDispatch } = useCampaignEditorContext();
  const linkToDisplayWebContent = useLinkToDisplayWebContent();

  return useCallback(
    (addToId: string) => {
      const id = uuid();
      const segmentId = uuid();

      const { nodes, edges } = Canvas.createFromState(state)
        .hideDropNodesFor(NodeTypeKeys.displayWebContentNodeType)
        .add(new DisplayWebContentNode(id), addToId)
        .convertToState();

      editorDispatch({
        type: 'ADD_DISPLAY_WEB_CONTENT',
        payload: {
          id,
          segmentId,
        },
      });

      const edge = edges.find(s => s.source === id);
      const nextNode = nodes.find(s => s.id === edge.target);
      if (nextNode.type === NodeTypeKeys.sendEmailNodeType) {
        linkToDisplayWebContent(nextNode.id, segmentId);
      }

      dispatch({
        type: 'UPDATE',
        payload: {
          nodes,
          edges,
        },
      });
    },
    [dispatch, editorDispatch, linkToDisplayWebContent, state],
  );
};
